import { useQuery, useMutation } from "react-apollo";
import {
  GET_SETTINGS,
  GET_APP_SETTINGS,
  GET_RENUMERATION_SETTINGS,
  UPDATE_RENUMERATION_SETTINGS,
  UPDATE_SETTINGS,
  UPDATE_PAYMENT_KEYS,
  UPDATE_SETTINGS_PARAMS,
  GET_COUNTRIES,
  ADD_COUNTRY,
  DELETE_COUNTRY,
  UPDATE_GLOBAL_SETTINGS,
  GET_STEPS_SETTINGS,
  GET_STEPS_SETTINGS_ADMIN,
  GET_PART_SETTINGS,
} from "graphql/tags/settings.tag";
import {
  GET_EMAIL_TEMPLATES,
  GET_EMAIL_TEMPLATE,
  UPDATE_TEMPLATE_MAIL,
} from "graphql/tags/mail.tag";
import {
  GET_NOTIFICATIONS_TEMPLATES,
  UPDATE_TEMPLATE_NOTIFICATION,
  GET_NOTIFICATION_TEMPLATE,
  GET_SMS_TEMPLATES,
  GET_SMS_TEMPLATE,
  UPDATE_TEMPLATE_SMS,
} from "graphql/tags/pushNotifications.tag";

import gql from "graphql-tag";

export const useQuerySetting = () => {
  const { data, loading, ...others } = useQuery(GET_SETTINGS);

  return {
    data: data?.myStore?.settings,
    loading,
    others,
  };
};
export const useQuerySettings = () => {
  const { data, ...others } = useQuery(GET_APP_SETTINGS);
  return {
    data: data?.getSettings,
    ...others,
  };
};
export const useQueryPartSettings = () => {
  const { data, ...others } = useQuery(GET_PART_SETTINGS);
  return {
    data: data?.getSettings,
    ...others,
  };
};
export const useQueryRenumerationSettings = () => {
  const { data, ...others } = useQuery(GET_RENUMERATION_SETTINGS);
  return {
    data: data?.getSettings?.renumeration,
    ...others,
  };
};
export const useMutationRenumerationSettings = () => {
  const [updateRenumerationSettings] = useMutation(
    UPDATE_RENUMERATION_SETTINGS
  );
  function updateRenumeration({ input }) {
    return updateRenumerationSettings({
      variables: {
        input,
      },
    });
  }
  return {
    updateRenumeration,
  };
};
export const useQuerySteps = () => {
  const { data, ...rest } = useQuery(GET_STEPS_SETTINGS);
  return {
    completedConfiguration: data?.getProfileCompletedConfiguration,
    ...rest,
  };
};
export const useQueryStepsAdmin = (store) => {
  const { data, ...rest } = useQuery(GET_STEPS_SETTINGS_ADMIN, {
    variables: {
      store,
    },
  });
  return {
    completedConfiguration: data?.getProfileCompletedConfiguration,
    ...rest,
  };
};
export const useMutationDeliverySettings = () => {
  const [updateDeliveryApiSetting] = useMutation(UPDATE_SETTINGS);
  function updateDeliveryApi(variables) {
    return updateDeliveryApiSetting({
      variables,
    });
  }
  return {
    updateDeliveryApi,
  };
};
export const useMuautionPaymentConfig = () => {
  const [updateSettingsKeys] = useMutation(UPDATE_PAYMENT_KEYS);
  function updatePaymentSettingsKeys({ input }) {
    return updateSettingsKeys({
      variables: {
        input,
      },
    });
  }
  return { updatePaymentSettingsKeys };
};
export const useMutationSettingsParamsConfig = () => {
  const [updateGlobal] = useMutation(UPDATE_GLOBAL_SETTINGS);
  const [updateParams] = useMutation(UPDATE_SETTINGS_PARAMS);
  function updateParamsSettings({ input }) {
    return updateParams({
      variables: {
        input,
      },
    });
  }
  function updateGlobalSettings({ input }) {
    return updateGlobal({
      variables: {
        input,
      },
    });
  }
  return { updateParamsSettings, updateGlobalSettings };
};

export const useQueryCountries = () => {
  const { data, ...rest } = useQuery(GET_COUNTRIES);
  return {
    data: data?.getCountries,
    ...rest,
  };
};
export const useMutationCountry = () => {
  const [addCountries] = useMutation(ADD_COUNTRY);
  const [deleteCountries] = useMutation(DELETE_COUNTRY);
  function addCountry({ input }) {
    return addCountries({
      variables: {
        input,
      },
      update: (cache, { data }) => {
        const dataa = cache.readQuery({
          query: GET_COUNTRIES,
        });
        cache.writeQuery({
          query: GET_COUNTRIES,
          data: {
            ...dataa,
            getCountries: [...dataa.getCountries, data?.addCountry],
          },
        });
      },
    });
  }
  function deleteCountry(id) {
    return deleteCountries({
      variables: { id },
      update: (cache, { data }) => {
        const dataa = cache.readQuery({
          query: GET_COUNTRIES,
        });
        cache.writeQuery({
          query: GET_COUNTRIES,
          data: {
            ...dataa,
            getCountries: [...dataa.getCountries?.filter((c) => c?.id !== id)],
          },
        });
      },
    });
  }
  return { addCountry, deleteCountry };
};

export const useQueryTemplatesEmails = () => {
  const { data, ...rest } = useQuery(GET_EMAIL_TEMPLATES);
  return {
    data: data?.getTemplatesEmail,
    ...rest,
  };
};
export const useQueryTemplateEmail = (id) => {
  const { data, ...rest } = useQuery(GET_EMAIL_TEMPLATE, {
    variables: {
      id,
    },
  });
  return {
    data: data?.getTemplateEmail,
    ...rest,
  };
};

export const useMutationMailTemplate = () => {
  const [updateMail] = useMutation(UPDATE_TEMPLATE_MAIL);
  function updateMailTemplate({ id, input }) {
    return updateMail({
      variables: {
        id,
        input,
      },
    });
  }
  return { updateMailTemplate };
};

export const useQuerySmsTemplates = () => {
  const { data, ...rest } = useQuery(GET_SMS_TEMPLATES);
  return {
    data: data?.getAllTemplatesSms,
    ...rest,
  };
};
export const useQueryTemplateSms = (id) => {
  const { data, ...rest } = useQuery(GET_SMS_TEMPLATE, {
    variables: {
      id,
    },
  });
  return {
    data: data?.getTemplatesSms,
    ...rest,
  };
};

export const useQueryNotificationsTemplates = () => {
  const { data, ...rest } = useQuery(GET_NOTIFICATIONS_TEMPLATES);
  return {
    data: data?.getTemplateNotifications,
    ...rest,
  };
};
export const useQueryTemplateNotification = (id) => {
  const { data, ...rest } = useQuery(GET_NOTIFICATION_TEMPLATE, {
    variables: {
      id,
    },
  });
  return {
    data: data?.getTemplateNotification,
    ...rest,
  };
};
export const useMutationSmsTemplate = () => {
  const [updateNotif] = useMutation(UPDATE_TEMPLATE_SMS);
  function updateNotificationTemplate({ id, input }) {
    return updateNotif({
      variables: {
        id,
        input,
      },
    });
  }
  return { updateNotificationTemplate };
};

export const useMutationNotificationTemplate = () => {
  const [updateNotif] = useMutation(UPDATE_TEMPLATE_NOTIFICATION);
  function updateNotificationTemplate({ id, input }) {
    return updateNotif({
      variables: {
        id,
        input,
      },
    });
  }
  return { updateNotificationTemplate };
};
const QUERY = gql`
  query {
    getStoreTypes {
      id
      name
      photoUrl
    }
  }
`;
export const useQueryStoreTypes = () => {
  const { data, loading, ...rest } = useQuery(QUERY);
  return {
    data: data?.getStoreTypes,
    loading,
    ...rest,
  };
};
export const useMutationStoreTypes = () => {
  const ADD = gql`
    mutation addStoreType($input: StoreTypeInput) {
      addStoreType(input: $input) {
        id
        name
        photoUrl
      }
    }
  `;
  const DELETE = gql`
    mutation deleteStoreType($id: ID) {
      deleteStoreType(id: $id) {
        id
      }
    }
  `;
  const UPDATE = gql`
    mutation updateStoreType($id: ID, $input: StoreTypeInput) {
      updateStoreType(id: $id, input: $input) {
        id
        name
        photoUrl
      }
    }
  `;
  const [addType] = useMutation(ADD);
  const [deleteType] = useMutation(DELETE);
  const [updateType] = useMutation(UPDATE);
  function addStoreType({ input }) {
    return addType({
      variables: {
        input,
      },
      update: (cache, { data }) => {
        let oldData = cache.readQuery({ query: QUERY });
        oldData = {
          ...oldData,
          getStoreTypes: [...oldData?.getStoreTypes, data.addStoreType],
        };
        cache.writeQuery({ query: QUERY, data: oldData });
      },
    });
  }
  function deleteStoreType(id) {
    return deleteType({
      variables: {
        id,
      },
      update: (cache, { data }) => {
        let oldData = cache.readQuery({ query: QUERY });
        oldData = {
          ...oldData,
          getStoreTypes: [
            ...oldData?.getStoreTypes?.filter((t) => t?.id !== id),
          ],
        };
        cache.writeQuery({ query: QUERY, data: oldData });
      },
    });
  }
  function updateStoreType({ id, input }) {
    return updateType({
      variables: {
        id,
        input,
      },
      update: (cache, { data }) => {
        let oldData = cache.readQuery({ query: QUERY });
        oldData = {
          ...oldData,
          getStoreTypes: [
            ...oldData?.getStoreTypes.map((currentType) =>
              currentType?.id === data?.updateStoreType?.id
                ? data?.updateStoreType
                : currentType
            ),
          ],
        };
        cache.writeQuery({ query: QUERY, data: oldData });
      },
    });
  }
  return {
    addStoreType,
    deleteStoreType,
    updateStoreType,
  };
};

const QUERY_TWO = gql`
  query {
    getStoreLabels {
      id
      name
      photoUrl
    }
  }
`;
export const useQueryStoreLabels = () => {
  const { data, loading, ...rest } = useQuery(QUERY_TWO);
  return {
    data: data?.getStoreLabels,
    loading,
    ...rest,
  };
};
export const useMutationStoreLabels = () => {
  const ADD = gql`
    mutation addStoreLabel($input: StoreLabelInput) {
      addStoreLabel(input: $input) {
        id
        name
        photoUrl
      }
    }
  `;
  const DELETE = gql`
    mutation deleteStoreLabel($id: ID) {
      deleteStoreLabel(id: $id) {
        id
      }
    }
  `;
  const UPDATE = gql`
    mutation updateStoreLabel($id: ID, $input: StoreLabelInput) {
      updateStoreLabel(id: $id, input: $input) {
        id
        name
        photoUrl
      }
    }
  `;
  const [addLabel] = useMutation(ADD);
  const [deleteLabel] = useMutation(DELETE);
  const [updateLabel] = useMutation(UPDATE);
  function addStoreLabel({ input }) {
    return addLabel({
      variables: {
        input,
      },
      update: (cache, { data }) => {
        let oldData = cache.readQuery({ query: QUERY_TWO });
        oldData = {
          ...oldData,
          getStoreLabels: [...oldData?.getStoreLabels, data.addStoreLabel],
        };
        cache.writeQuery({ query: QUERY_TWO, data: oldData });
      },
    });
  }
  function deleteStoreLabel(id) {
    return deleteLabel({
      variables: {
        id,
      },
      update: (cache, { data }) => {
        let oldData = cache.readQuery({ query: QUERY_TWO });
        oldData = {
          ...oldData,
          getStoreLabels: [
            ...oldData?.getStoreLabels?.filter((t) => t?.id !== id),
          ],
        };
        cache.writeQuery({ query: QUERY_TWO, data: oldData });
      },
    });
  }
  function updateStoreLabel({ id, input }) {
    return updateLabel({
      variables: {
        id,
        input,
      },
      update: (cache, { data }) => {
        let oldData = cache.readQuery({ query: QUERY_TWO });
        oldData = {
          ...oldData,
          getStoreLabels: [
            ...oldData?.getStoreLabels.map((currentType) =>
              currentType?.id === data?.updateStoreLabel?.id
                ? data?.updateStoreLabel
                : currentType
            ),
          ],
        };
        cache.writeQuery({ query: QUERY_TWO, data: oldData });
      },
    });
  }
  return {
    addStoreLabel,
    deleteStoreLabel,
    updateStoreLabel,
  };
};
// const useQuerySettingsRenumeration = () => {
//   const {} = useQuery(gql`
//     query {
//       getSettings {
//         renumeration {
//           feeHosting {
//             status
//             defaultApplicablePrice
//             exceptions {
//               structure
//               fee
//             }
//           }
//         }
//       }
//     }
//   `);
// };
